import styled from 'styled-components';

export const Card = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.colors.white};
  border: 1px solid ${({ theme }) => theme.colors.black_40};
  border-radius: 0.5625rem;
  padding: ${({ theme }) => theme.spacing.two};
  width: 100%;
  max-width: 26.4375rem;
  box-shadow: 0 4px 19px 0 rgba(0, 0, 0, 0.24);

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    margin: 0 ${({ theme }) => theme.spacing.one};
  }
`;

export const FeatureList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0 0 auto 0;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.zero_3};
`;

export const FeatureItem = styled.li`
  display: flex;
  align-items: flex-start;
  gap: ${({ theme }) => theme.spacing.zero_2};
`;

export const Title = styled.p`
  font-family: ${({ theme }) => theme.fontFamily.semiBold};
  font-size: ${({ theme }) => theme.fontSize.sm};
  color: ${({ theme }) => theme.colors.black_100};
  line-height: 1.5rem;
`;

export const Description = styled.p`
  font-family: ${({ theme }) => theme.fontFamily.regular};
  font-size: ${({ theme }) => theme.fontSize.xxs};
  color: ${({ theme }) => theme.colors.black_100};
  line-height: 0.875rem;
`;
